














import Vue from "vue";
import { SlotRequestInterface, LoggedInDiscordUser } from "@/types";
import User from "@/User";

export default Vue.extend({
  data() {
    return {
      eventName: localStorage.getItem("eventName"),
      slotRequest: {} as SlotRequestInterface,
      slotEndpoint: "/arma/slots/",
    };
  },
  computed: {
    redirectUri(): string {
      return encodeURI(`${process.env.VUE_APP_BASE_URI + this.$route.path}`);
    },
    eventUri(): string {
      return encodeURI(`/events/${this.eventName}`);
    },
    code(): string {
      if (typeof this.$route.query.code === "string") {
        return this.$route.query.code;
      }
      return "";
    },
  },
  async created() {
    const response = await this.getAccessToken(this.code, this.redirectUri);

    const user = await User.getDiscordUser(response.data.access_token);

    const validUntil = new Date();
    validUntil.setSeconds(validUntil.getSeconds() + response.data.expires_in);

    const loggedInDiscordUser: LoggedInDiscordUser = {
      id: user.data.id,
      username: user.data.username,
      globalName: user.data.globalName,
      discriminator: user.data.discriminator,
      avatar: user.data.avatar,
      accessToken: response.data.access_token,
      refreshToken: response.data.refresh_token,
      validUntil,
    };

    localStorage.setItem("user", JSON.stringify(loggedInDiscordUser));

    const previousRoute = localStorage.getItem("previousRoute");

    if (previousRoute === null) {
      this.$router.push("/");
    } else {
      await this.$router.push(previousRoute);
      this.$router.go(0);
    }
  },
  methods: {
    async getAccessToken(code: string, redirectUri: string) {
      return await this.axios.get("/users/discord", {
        params: {
          code,
          redirect_uri: redirectUri,
        },
      });
    },
  },
});
